export default __webpack_public_path__ + "static/media/DSC040131735.e8ff06c0.jpg";